import { useEffect, useRef, useState } from 'react';
import { BgVideo } from '../BgVideo/BgVideo';
import { Message } from '../Message/Message';

import styles from './MessagesList.module.css';
import logo from '../../assets/images/logo.png';

export const MessagesList = ({ messages, speed }) => {
  const [slideClass, setSlideClass] = useState('');
  const firstIdRef = useRef(messages[0]?.UUID);

  useEffect(() => {
    const currentFirst = messages[0]?.UUID;
    if (currentFirst === firstIdRef.current) return;
    firstIdRef.current = currentFirst;

    //чтобы анимация перезапускалась
    setSlideClass((prev) =>
      prev === styles.slideA ? styles.slideB : styles.slideA,
    );
  }, [messages]);

  return (
    <div className={styles.wrapper}>
      <img src={logo} alt="" className={styles.logo} />

      <div className={styles.viewport}>
        <div
          className={`${styles.track} ${slideClass}`}
          style={{ '--speed': `${speed}ms` }}
        >
          {messages.map((item) => (
            <div key={item.UUID} className={styles.item}>
              <Message
                message={item.message}
                rotateSign={item.rotateSign}
                speed={speed}
                randomDelay={item.randomDelay}
              />
            </div>
          ))}
        </div>
      </div>
      <BgVideo />
    </div>
  );
};
